/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popJoinLuckyBox.vue?vue&type=template&id=efc99370&scoped=true"
import script from "./popJoinLuckyBox.vue?vue&type=script&lang=js"
export * from "./popJoinLuckyBox.vue?vue&type=script&lang=js"
import style0 from "./popJoinLuckyBox.vue?vue&type=style&index=0&id=efc99370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc99370",
  null
  
)

export default component.exports